import React from 'react'
import { Route, Routes } from 'react-router-dom'
import NotFoundPage from '../pages/404/NotFoundPage'
import {Container} from 'react-bootstrap'
import MenuAdmin from '../components/menus/menu-admin'
import Dashboard from '../pages/admin/Dashboard'
import Users from '../pages/admin/users/Users'
import UserEdit from '../pages/admin/users/UserEdit'
import UserInsert from '../pages/admin/users/UserInsert'
import Origens from '../pages/admin/origens/Origens'
import OrigenEdit from '../pages/admin/origens/OrigenEdit'
import OrigenInsert from '../pages/admin/origens/OrigenInsert'
import Machineries from '../pages/admin/machineries/Machinaries'
import MachineryEdit from '../pages/admin/machineries/MachineryEdit'
import MachineryInsert from '../pages/admin/machineries/MachineryInsert'
import Crops from '../pages/admin/crops/Crops'
import CropEdit from '../pages/admin/crops/CropEdit'
import CropInsert from '../pages/admin/crops/CropInsert'
import Products from '../pages/admin/products/Products'
import ProductEdit from '../pages/admin/products/ProductEdit'
import ProductInsert from '../pages/admin/products/ProductInsert'
import Labors from '../pages/admin/labors/Labors'
import LaborEdit from '../pages/admin/labors/LaborEdit'
import LaborInsert from '../pages/admin/labors/LaborInsert'
import Farms from '../pages/admin/farms/Farms'
import FarmEdit from '../pages/admin/farms/FarmEdit'
import FarmInsert from '../pages/admin/farms/FarmInsert'
import Plots from '../pages/admin/plots/Plots'
import PlotEdit from '../pages/admin/plots/PlotEdit'
import PlotInsert from '../pages/admin/plots/PlotInsert'
// import Campaigns from '../pages/admin/campaigns/Campaigns'
// import CampaignEdit from '../pages/admin/campaigns/CampaignEdit'
// import CampaignInsert from '../pages/admin/campaigns/CampaignInsert'
import Counters from '../pages/admin/counters/Counters'
import CounterEdit from '../pages/admin/counters/CounterEdit'
import CounterInsert from '../pages/admin/counters/CounterInsert'
import CounterRegister from '../pages/admin/counters/CounterRegister'
import Logs from '../pages/admin/logs/Logs'

export default function AdminRouter () {   
    return (
        <Container className='cabecera'>
            <MenuAdmin/>
            <Routes>
                <Route path="/dashboard" element={<Dashboard/>}/>
                <Route path="/users" element={<Users/>}/>
                <Route exact path="/user/:id" element={<UserEdit/>}/>
                <Route exact path="/user" element={<UserInsert/>}/>
                <Route path="/origens" element={<Origens/>}/>
                <Route exact path="/origen/:id" element={<OrigenEdit/>}/>
                <Route exact path="/origen" element={<OrigenInsert/>}/>
                <Route path="/machineries" element={<Machineries/>}/>
                <Route exact path="/machinery/:id" element={<MachineryEdit/>}/>
                <Route exact path="/machinery" element={<MachineryInsert/>}/>
                <Route path="/crops" element={<Crops/>}/>
                <Route exact path="/crop/:id" element={<CropEdit/>}/>
                <Route exact path="/crop" element={<CropInsert/>}/>
                <Route path="/farms" element={<Farms/>}/>
                <Route exact path="/farm/:id" element={<FarmEdit/>}/>
                <Route exact path="/farm" element={<FarmInsert/>}/>
                <Route path="/plots" element={<Plots/>}/>
                <Route exact path="/plot/:id" element={<PlotEdit/>}/>
                <Route exact path="/plot" element={<PlotInsert/>}/>
                {/* <Route path="/campaigns" element={<Campaigns/>}/>
                <Route exact path="/campaign/:id" element={<CampaignEdit/>}/>
                <Route exact path="/campaign" element={<CampaignInsert/>}/> */}
                <Route path="/products" element={<Products/>}/>
                <Route exact path="/product/:id" element={<ProductEdit/>}/>
                <Route exact path="/product" element={<ProductInsert/>}/>
                <Route path="/labors" element={<Labors/>}/>
                <Route exact path="/labor/:id" element={<LaborEdit/>}/>
                <Route exact path="/labor" element={<LaborInsert/>}/>
                <Route path="/counters" element={<Counters/>}/>
                <Route exact path="/counter/:id" element={<CounterEdit/>}/>
                <Route exact path="/counter" element={<CounterInsert/>}/>
                <Route exact path="/checkcounter/:id" element={<CounterRegister/>}/>
                <Route path="/logs" element={<Logs/>}/>
                <Route path="*" element={<NotFoundPage />}/>
            </Routes>
        </Container>
    )
}